import { Send, MessageCircle, MessageSquare } from 'lucide-react';
import ScamflagWordmark from './ScamflagWordmark';
import NewsletterForm from './NewsletterForm';

type FooterProps = {
  onNavigate: (page: string) => void;
};

export default function Footer({ onNavigate }: FooterProps) {
  const currentYear = new Date().getFullYear();

  const footerLinks = [
    { label: 'About Us', page: 'about' },
    { label: 'How It Works', page: 'how-it-works' },
    { label: 'Terms and Conditions', page: 'terms' },
    { label: 'Privacy Policy', page: 'privacy' },
    { label: 'Request Review', page: 'request-review' },
  ];

  return (
    <footer className="text-white border-t border-line" style={{ backgroundColor: '#1A1A1A' }}>
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-6">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
          <div>
            <div className="mb-2">
              <ScamflagWordmark iconClassName="w-7 h-7" wordmarkClassName="text-sm" />
            </div>
            <p className="text-xs text-ash-600 leading-relaxed">
              A community-powered watchdog and digital fraud intelligence platform protecting everyday people from online scams and financial fraud. We investigate, verify, and publish - so you don't get caught out. If it smells wrong, we flag it.
            </p>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2 text-xs">Quick Links</h3>
            <ul className="space-y-1">
              {footerLinks.slice(0, 3).map((link) => (
                <li key={link.page}>
                  <button onClick={() => onNavigate(link.page)} className="text-xs text-white/70 hover:text-white transition">{link.label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2 text-xs">Legal & Support</h3>
            <ul className="space-y-1">
              {footerLinks.slice(3).map((link) => (
                <li key={link.page}>
                  <button onClick={() => onNavigate(link.page)} className="text-xs text-white/70 hover:text-white transition">{link.label}</button>
                </li>
              ))}
            </ul>
            {/* Newsletter subscription in footer */}
            <div className="mt-4 pt-3 border-t border-line/50">
              <NewsletterForm source="footer" variant="inline" />
            </div>
          </div>

          <div>
            <h3 className="text-white font-semibold mb-2 text-xs">Community</h3>
            <div className="space-y-1">
              <a href="https://t.me/scamflag" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs text-white/70 hover:text-white transition min-h-[44px] py-2">
                <Send className="w-3 h-3" />Telegram
              </a>
              <a href="https://tiktok.com/@scamflag" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs text-white/70 hover:text-white transition min-h-[44px] py-2">
                <MessageCircle className="w-3 h-3" />TikTok
              </a>
              <a href="https://whatsapp.com/channel/0029VbBUYlDFHWpuVfnmNp0J" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1.5 text-xs text-white/70 hover:text-white transition min-h-[44px] py-2">
                <MessageSquare className="w-3 h-3" />WhatsApp
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-line pt-4">
          <p className="text-[10px] text-white/50 leading-relaxed mb-2 text-center max-w-4xl mx-auto">
            SCAMFLAG is a user-generated reporting platform. All posts reflect users' personal experiences and opinions. The platform and its owners are not responsible for the accuracy of user content.
          </p>
          <div className="flex flex-col gap-2 text-center sm:flex-row sm:justify-between sm:items-center text-[10px] text-white/50">
            <span>{currentYear} SCAMFLAG. All rights reserved.</span>
            <span>Stay safe online. Report scams. Protect others.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
